import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, Globe } from 'lucide-react';
import { useAuth } from '../lib/auth';

export default function NotFound() {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  // Keep logged-in users inside the dashboard shell.
  const exchangePath = isAuthenticated ? '/dashboard/exchange' : '/exchange';
  return (
    <div className="min-h-[calc(100vh-82px)] flex items-center justify-center">
      <div className="text-center px-4">
        <div className="font-display text-8xl text-stone-200 mb-4">404</div>
        <h1 className="font-display text-2xl text-stone-950 mb-2">Page not found</h1>
        <p className="text-sm text-stone-500 mb-8">The page you're looking for doesn't exist or has been moved.</p>
        <div className="flex items-center justify-center gap-3">
          <Link to="/" className="btn-primary gap-2"><Home size={16} /> Home</Link>
          <Link to={exchangePath} className="btn-secondary gap-2"><Globe size={16} /> Exchange</Link>
        </div>
      </div>
    </div>
  );
}
